/**
 * Storage type for choosing between localStorage and sessionStorage.
 * Default is 'local' (localStorage).
 */
export type StorageType = 'local' | 'session';

export interface StorageOptions {
  expiresIn?: number; // milliseconds
  storageType?: StorageType; // default: 'local'
}

export interface StoredItem<T> {
  value: T;
  expiresAt?: number;
}

/**
 * Predefined storage keys for type safety and validation.
 */
export const STORAGE_KEYS = {
  SELECTED_MEMBER: 'SELECTED_MEMBER',
  SELECTED_MODEL: 'SELECTED_MODEL',
  SELECTED_GROUP_FOR_MODEL: 'SELECTED_GROUP_FOR_MODEL',
  SELECTED_PROJECT: 'SELECTED_PROJECT',
  SELECTED_PROJECT_TEAM_SLUG: 'SELECTED_PROJECT_TEAM_SLUG',
  SELECTED_TEAM: 'SELECTED_TEAM',
  RECENT_PROJECTS: 'RECENT_PROJECTS',
  // User preferences
  SETTINGS: 'SETTINGS',
  PROFILE: 'PROFILE',
  PREFERENCES: 'PREFERENCES',
  CART: 'CART',
  SESSION_TOKEN: 'SESSION_TOKEN',
  LANGUAGE: 'LANGUAGE',
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];

/**
 * The cached storage structure - all items stored as one encrypted chunk.
 * Uses string index to support both predefined keys and dynamically registered keys.
 */
export type CachedStorage = Record<string, StoredItem<unknown> | undefined>;
